import React, { FC, useEffect, useRef, useState } from 'react';
import { TeamModel } from '../../models/TeamModel';
import { KTSVG } from '../../../../../_metronic/helpers';

interface DropdownProps {
  item: TeamModel;
  onEdit: (id: number) => void;
  onDelete: (id: number) => void;
}

const DropdownOption: FC<DropdownProps> = ({
  item,
  onEdit,
  onDelete,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleEdit = () => {
    setIsOpen(false);
    onEdit(item.id);
  };

  const handleDelete = () => {
    setIsOpen(false);
    onDelete(item.id);
  };

  return (
    <div
      className="team-admin-actions position-relative"
      ref={dropdownRef}
    >
      <button
        type="button"
        className="btn btn-icon btn-sm btn-light"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <KTSVG path="/media/svg/nobilis/dots-horizontal.svg" />
      </button>

      {isOpen && (
        <div
          className="menu menu-sub menu-sub-dropdown menu-column menu-rounded
                     menu-gray-800 menu-state-bg-light-primary fw-semibold fs-7
                     w-150px py-4 show"
          style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            zIndex: 1000,
          }}
        >
          <div className="menu-item px-3">
            <button
              type="button"
              className="menu-link px-3 w-100 text-start border-0 bg-transparent"
              onClick={handleEdit}
            >
              Edit
            </button>
          </div>

          <div className="menu-item px-3">
            <button
              type="button"
              className="menu-link px-3 w-100 text-start border-0 bg-transparent"
              onClick={handleDelete}
            >
              Remove
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownOption;